import { AnswerService } from './answer/answer.service';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { QuestionType } from '../models/enums';
import { CustomAnswerModel, SpecialAnswerModel } from '../models/comparison/comparison-answers';

@Injectable()
export class FormBuilderService {

  constructor(private answerService: AnswerService) { }

  public handleQuestionAnswer(newValue: any, questionForm: FormGroup): void {
    this.answerChangeHandler(newValue, questionForm, this.answerService.answerSetModel.customAnswers, 'custom');
  }

  public handleSpecialAnswer(newValue: any, questionForm: FormGroup) {
    this.answerChangeHandler(newValue, questionForm, this.answerService.answerSetModel.specialAnswers, 'special');
  }

  public handleProfileAnswer(newValue: any, questionForm: FormGroup, index: number = 0) {
    if (!this.answerService.answerSetModel.profileAnswers[index]) {
      this.answerService.answerSetModel.profileAnswers.push([]);
    }
    this.answerChangeHandler(newValue, questionForm, this.answerService.answerSetModel.profileAnswers[index], 'custom');
  }

  private answerChangeHandler(newValue: any, questionForm: FormGroup, container: any[], type: 'custom' | 'special') {
    const formValue = questionForm.value;
    const isEmptyValue = newValue === null || newValue === undefined || (Array.isArray(newValue) && newValue.length === 0);

    let answer = container.find(x => x.questionId === formValue.questionId);

    if (isEmptyValue && answer) {
      container = container.filter(x => x.questionId !== formValue.questionId);
      this.answerService.emitChange();
    } else if (!isEmptyValue) {
      if (!answer) {
        answer = type === 'custom'
          ? new CustomAnswerModel({
            type: formValue.question.type,
            specification: formValue.question.specification,
            questionId: formValue.questionId
          })
          : new SpecialAnswerModel({
            questionId: formValue.questionId,
            property: formValue.property
          });
        container.push(answer);
      }
      if (type === 'custom') {
        this.setAnswer(newValue, answer);
      } else {
        answer.answer = newValue;
      }
      this.answerService.emitChange();
    }
    // console.log(questionForm);
  }

  public setAnswer(value: any, answer: CustomAnswerModel): void {
    switch (answer.type) {
      case QuestionType.MultiSelect:
      case QuestionType.Checkbox:
        answer.optionsId = value;
        break;
      case QuestionType.DatePicker:
        const reg = /^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/gi;
        if (reg.test(value)) {
          answer.date = this.parseDate(value).toDateString();
        }
        break;
      case QuestionType.Digits:
        answer.digit = value;
        break;
      case QuestionType.Text:
      case QuestionType.PhoneNumber:
        answer.text = value;
        break;
      case QuestionType.YesNoRadioButton:
      case QuestionType.RadioButton:
      case QuestionType.Select:
        answer.optionId = value;
        break;
      default:
        break;
    }
  }

  private parseDate(dateString: string): Date {
    const parts = dateString.split('/');
    return new Date(parseInt(parts[2], 10),
      parseInt(parts[0], 10) - 1,
      parseInt(parts[1], 10));
  }
}
